import React from "react";
import { Link } from "react-router-dom";
import { useStore } from "../lib/store";
import { formatINR } from "../lib/api";
import { useSEO } from "../lib/seo";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { wishlist, toggleWishlist } = useStore();
  useSEO({ title: "Wishlist — Haven Hives", description: "The little joys you've saved for later." });

  if (wishlist.length === 0) {
    return (
      <div className="max-w-xl mx-auto text-center py-24 px-5" data-testid="wishlist-empty">
        <div className="w-20 h-20 rounded-full bg-blush flex items-center justify-center mx-auto"><Heart className="w-8 h-8" /></div>
        <h1 className="font-display text-3xl font-semibold mt-6">Your wishlist is empty</h1>
        <p className="text-charcoal/70 mt-2">Tap the heart on any product to save it here for later.</p>
        <Link to="/collections/shop-all" className="inline-block mt-6 bg-forest text-white hover:bg-forest-dark px-8 py-3.5 rounded-full" data-testid="wishlist-empty-cta">Find something to love</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1700px] xl:px-14 mx-auto px-5 sm:px-8 py-12" data-testid="wishlist-page">
      <h1 className="font-display font-semibold text-3xl sm:text-4xl">Your wishlist</h1>
      <p className="text-charcoal/70 mt-2 text-sm">{wishlist.length} little {wishlist.length === 1 ? "joy" : "joys"} saved.</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mt-8" data-testid="wishlist-grid">
        {wishlist.map((p) => (
          <article key={p.slug} className="group relative" data-testid={`wishlist-item-${p.slug}`}>
            <div className="relative overflow-hidden rounded-3xl bg-white card-outline">
              <Link to={`/products/${p.slug}`} className="block aspect-square overflow-hidden">
                <img src={p.image} alt={p.name} width="400" height="400" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </Link>
              <button onClick={() => toggleWishlist(p)} aria-label={`Remove ${p.name} from wishlist`} data-testid={`wishlist-remove-${p.slug}`}
                className="absolute top-3 right-3 p-2.5 rounded-full bg-cream text-coral">
                <Heart className="w-4 h-4" fill="currentColor" />
              </button>
            </div>
            <div className="pt-3 px-1">
              <h3 className="font-display font-medium text-[15px] leading-snug">
                <Link to={`/products/${p.slug}`}>{p.name}</Link>
              </h3>
              <p className="font-bold mt-1">{formatINR(p.price)}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
